import * as React from "react";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ReleaseNote } from "../../../../../services/release-admin/types/release-note";
import { DetailContainer } from "../../controllers/releases/detail/common/detail-container";
import {
  listNotes,
  createNote,
  updateNote,
  deleteNote,
} from "../../sdk/release-admin";
import { useParams } from "react-router";
import { useHistory } from "react-router";
import Back from "../../components/basics/icons/back";
import styled from "styled-components";
import { Input, CircularProgress } from "@material-ui/core";
import TrashIcon from "@material-ui/icons/DeleteOutline";
import FlagIcon from '@material-ui/icons/Flag';
import EditIcon from "@material-ui/icons/Edit";

export const ArtistNotesPage: React.FC = () => {
  const history = useHistory();

  const { artistId } = useParams<{ artistId: string }>();
  const [noteArray, setNoteArray] = React.useState<any>({});
  const [noteEdit, setNoteEdit] = React.useState<any>({});
  const [noteEditLoading, setNoteEditLoading] = React.useState<any>({});

  const [loading, setLoading] = React.useState(false);
  const [note, setNote] = React.useState("");
  const [watchlistNote, setWatchlistNote] = React.useState<boolean>(false);
  const [notes, setNotes] = React.useState<ReleaseNote[]>([]);

  React.useEffect(() => {
    listNotes(artistId).then((response) => setNotes(response.results));
  }, [artistId]);

  const sendNewNote = async () => {
    setLoading(true);
    const newNote = await createNote(artistId, note, watchlistNote);
    setNotes([newNote].concat(notes));
    setLoading(false);
    setNote("");
  };
  const goBack = () => {
    history.goBack();
  };

  const updateNoteHandler = async (note: ReleaseNote, entry: string) => {
    setNoteEditLoading({
      ...noteEditLoading,
      [entry]: true,
    });
    const response = await updateNote(note, noteArray[entry]);
    const updated = [
      ...notes.map((noteFilter) => {
        if (noteFilter.created_at === note.created_at) {
          return response;
        } else {
          return noteFilter;
        }
      }),
    ];
    if (response) {
      setNotes(updated);
      setNoteEditLoading({
        ...noteEditLoading,
        [entry]: false,
      });
    }
    setNoteEdit({
      ...noteEdit,
      [entry]: !noteEdit[entry],
    });
  };

  const deleteNoteHandler = async (
    releaseId: string,
    userId: string,
    created_at: Date,
    entry: string,
    watchlistNote: boolean
  ) => {
    setNoteEditLoading({
      ...noteEditLoading,
      [entry]: true,
    });
    const response = await deleteNote(releaseId, userId, created_at as Date, watchlistNote);
    if (response) {
      setNotes(notes.filter((note) => note.created_at !== created_at));
      setNoteEditLoading({
        ...noteEditLoading,
        [entry]: false,
      });
    }
  };

  return (
    <DetailContainer>
      <IconWrapper>
        <Back onClick={goBack} />
      </IconWrapper>
      <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={10}>
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={watchlistNote}
                    disabled={notes.filter((n) => n.watchlistNote).length > 0}
                    onChange={() => setWatchlistNote(!watchlistNote)}
                    color="default"
                  />
                }
                label="Watchlist"
              />
            </Grid>
          </Grid>
      </Grid>
      <TextField
        label="New note..."
        multiline
        fullWidth
        rows={6}
        value={note}
        onChange={(ev) => setNote(ev.target.value || "")}
        disabled={loading}
      />
      <Button
        disabled={loading || !note}
        onClick={() => sendNewNote()}
        fullWidth
        variant="contained"
        style={{ marginBottom: "1rem" }}
      >
        {loading ? "Saving..." : "Save"}
      </Button>
      {notes.map((note, i) => (
        <Accordion key={i} defaultExpanded={true}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id={`panel-header-${i}`}
          >
            <Typography style={{ width: "150px" }}>
              {new Date(note.created_at).toDateString()}
            </Typography>
            <Typography style={{ width: "150px" }}>
              <b>From:</b>
              <br />
              {note.editorEmail || "?"}
            </Typography>
            <FlagIcon/>
          </AccordionSummary>
          <AccordionDetails>
            <Flex>
              {noteEdit[note.entry] ? (
                <>
                  <Input
                    placeholder="notes"
                    inputProps={{ "aria-label": "search" }}
                    style={{ width: "300px" }}
                    value={noteArray[note.entry]}
                    defaultValue={note.entry}
                    onChange={(event) => {
                      setNoteArray({
                        ...noteArray,
                        [note.entry]: event.target.value,
                      });
                    }}
                  />
                  <Button
                    onClick={() => updateNoteHandler(note, note.entry)}
                    style={{ marginBottom: "1rem" }}
                  >
                    {noteEditLoading[note.entry] ? "Updating..." : "Update"}
                  </Button>
                </>
              ) : (
                <Typography style={{ whiteSpace: "pre-line" }}>
                  {note.entry}
                </Typography>
              )}
              {!noteEdit[note.entry] && (
                <ButtonWrapper>
                  <EditIcon
                    onClick={() => {
                      setNoteArray({
                        ...noteArray,
                        [note.entry]: note.entry,
                      });
                      setNoteEdit({
                        ...noteEdit,
                        [note.entry]: !noteEdit[note.entry],
                      });
                    }}
                  />
                  {noteEditLoading[note.entry] ? (
                    <CircularProgress size={"24px"} />
                  ) : (
                    <TrashIcon
                      onClick={() =>
                        deleteNoteHandler(
                          note.releaseId,
                          note.userId,
                          note.created_at,
                          note.entry,
                          note.watchlistNote || false
                        )
                      }
                    />
                  )}
                </ButtonWrapper>
              )}
            </Flex>
          </AccordionDetails>
        </Accordion>
      ))}
    </DetailContainer>
  );
};

const IconWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
`;
